import { accountByIdPath } from './account';
import {
  accounts,
  accountMargins,
  fetchAccounts,
  accountMarginReport,
  accountsStatus,
  saveLink,
  invoices,
  userOnProjectStats,
  fetchSowAdminAccounts,
  getAccountAndProjectList,
  getAccountByZohoCrmId,
} from './accounts';
import {
  editProject,
  projectAndMembers,
  projectMargins,
  projectStatus,
  projectTimetracking,
  fetchHeadcountChanges,
  saveHeadcountChanges,
} from './projects';
import { authLogin, authCustomLogin } from './auth';
import { contractor, locations, contractorsByZoho } from './contractor';
import {
  departments,
  financeDepartmentId,
  rootDepartments,
} from './departments';
import {
  kpiAssignments,
  allKpiAssignmentsForUser,
  sharedResultsForAssignment,
  bonusPlanUpdateSnippet,
  massEditKpiAssignments,
} from './kpiAssignments';
import {
  kpiDefinition,
  kpiDefinitionId,
  kpiDefinitionOwners,
  kpiDefinitionCategories,
} from './kpiDefinition';
import { kpiMetrics, kpiOwners, kpiMetricsByZoho } from './kpiMetrics';
import {
  adjustKpis,
  approveKpis,
  checkApproved,
  closeCurrentPeriod,
  submissions,
  submitKpis,
  calculateKpiBonus,
} from './kpiValueSubmission';
import { periods, currentPeriod } from './periods';
import { reports } from './reports';
import { reportIssue, reportIncorrectReport } from './reportIssue';
import { myMetrics } from './myMetrics';
import {
  usersList,
  allUsersList,
  userProfile,
  userAccountsCount,
  fetchCompensationRange,
  usersOfKpiDefinition,
} from './users';
import {
  fetchUserBonusPlan,
  updateUserBonusPlan,
  getBonusesByUserId,
} from './bonuses';
import { statusReport } from './statusReport';
import { assessmentCreate } from './assessment';
import { clientInvoiceGenerate } from './clientInvoice';
import {
  createAlert,
  getAlert,
  updateAlert,
  getAlerts,
  resolveAlert,
} from './alert';
import {
  adminReports,
  sharedMetricsInconsistencies,
  apiRecalculateSharedMetrics,
} from './admin';
import { saveOperationalCost } from './operationalCost';
import {
  resourceRequestMove,
  resourceRequestEdit,
  resourceRequestDeactivate,
  resourceRequestDeactivateMultiple,
} from './resources';
import {
  executeSowChangeReq,
  fetchSowChangeReqs,
  recentSowChanges,
  rejectSowChangeReq,
} from './sow-change-reqs';
import {
  getQuarterlyRevenueAccount,
  quarterlyRevenueById,
  createQuarterlyRevenueSummary,
  editQuarterlyRevenueSummary,
  exportQuarterlyRevenue,
} from './quarterlyRevenue';

export const apiEndpoints = {
  accountByIdPath,
  accountMargins,
  accountsStatus,
  accounts,
  editProject,
  assessmentCreate,
  fetchAccounts,
  fetchSowAdminAccounts,
  saveLink,
  projectMargins,
  projectStatus,
  projectTimetracking,
  adjustKpis,
  approveKpis,
  authCustomLogin,
  authLogin,
  checkApproved,
  closeCurrentPeriod,
  contractorsByZoho,
  contractor,
  currentPeriod,
  departments,
  rootDepartments,
  financeDepartmentId,
  kpiAssignments,
  allKpiAssignmentsForUser,
  sharedResultsForAssignment,
  kpiDefinition,
  kpiDefinitionId,
  kpiDefinitionOwners,
  kpiDefinitionCategories,
  kpiMetrics,
  kpiOwners,
  kpiMetricsByZoho,
  locations,
  periods,
  reports,
  adminReports,
  reportIssue,
  submissions,
  submitKpis,
  calculateKpiBonus,
  myMetrics,
  userProfile,
  usersList,
  userAccountsCount,
  accountMarginReport,
  fetchCompensationRange,
  statusReport,
  fetchUserBonusPlan,
  updateUserBonusPlan,
  getBonusesByUserId,
  bonusPlanUpdateSnippet,
  reportIncorrectReport,
  clientInvoiceGenerate,
  projectAndMembers,
  createAlert,
  getAlert,
  updateAlert,
  allUsersList,
  getAlerts,
  resolveAlert,
  sharedMetricsInconsistencies,
  usersOfKpiDefinition,
  massEditKpiAssignments,
  apiRecalculateSharedMetrics,
  invoices,
  fetchHeadcountChanges,
  saveHeadcountChanges,
  saveOperationalCost,
  userOnProjectStats,
  resourceRequestMove,
  resourceRequestEdit,
  resourceRequestDeactivate,
  resourceRequestDeactivateMultiple,
  fetchSowChangeReqs,
  executeSowChangeReq,
  rejectSowChangeReq,
  recentSowChanges,
  getAccountAndProjectList,
  getAccountByZohoCrmId,
  getQuarterlyRevenueAccount,
  createQuarterlyRevenueSummary,
  editQuarterlyRevenueSummary,
  quarterlyRevenueById,
  exportQuarterlyRevenue,
};
